import { SearchField } from '@/components/Shared/SearchField';
import { useTranslation } from 'react-i18next';

interface ProductSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export function ProductSearch({ value, onChange }: ProductSearchProps) {
  const { t } = useTranslation('entity-portal');

  return (
    <SearchField
      value={value}
      onChange={onChange}
      placeholder={t('productRegistry.productRegistrySearchPlaceholder')}
      aria-label={t('productRegistry.productRegistrySearchPlaceholder')}
      sx={{ minWidth: { xs: '100%', md: 280 }, maxWidth: 360 }}
    />
  );
}
